//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MoreInfoButton from './MoreInfoButton.vue';

export default {
  name: 'PackageGymExplorer',
  components: {
    MoreInfoButton,
  },
  data: () => ({
    bag: { title: 'FightCamp Free-standing Bag', body: 'The FightCamp free standing bag is the best of its kind. It features a two-part stem designed for maximum shock absorption and a new hook-and-loop tension lock that attaches the cover of the bag to the base. This is the first free-standing bag that allows you to go all-out without unforgiving bag displacements.' },
    trackers: { title: 'FightCamp Punch Trackers', body: 'Our Punch Trackers unlock all of the most powerful FightCamp features. Used by many of the top Fighters in the world, they track and display punch volume, speed and Output in real time.' },
    mat: { title: 'Heavy Workout Mat', body: 'Use the same flooring the pros use. These mats provide shock absorption and a high friction surface to keep you safe and to protect your floor from scuff marks. Made of 8 interlocking tiles, you can rearrange the mats to perfectly fit in your space.' },
    gloves: { title: 'Premium Boxing Gloves', body: 'Get all the protection and function of a pro-fighter glove with a sleek, designer aesthetic. The FightCamp gloves are 100 percent handmade and carefully crafted to provide elevated comfort and increased durability.' },
    wraps: { title: 'FightCamp Quick Wraps', body: 'Our quick wraps are intelligently designed to protect your hands, secure your wrists and hold your Punch Trackers. They’re equipped with knuckle padding, additional wrist wrapping for security, and a handy little pocket. Simply slide them on, insert your Punch Trackers (round edge toward your fist), complete the wrapping and you’re ready to go.' },
  }),
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  methods: {
    bringToFront(event) {
      const dots = document.getElementsByClassName('equipment');
      Array.prototype.forEach.call(dots, (dot) => {
        // eslint-disable-next-line no-param-reassign
        dot.style.zIndex = 5;
      });

      let equipmentContainer;
      if (event.target.classList.contains('equipment')) {
        equipmentContainer = event.target;
      } else {
        equipmentContainer = event.target.closest('.equipment');
      }

      equipmentContainer.style.zIndex = 10;
    },
  },
};
